import { useShowContext } from 'framework/show';
import { useEmployeeDashboardActions } from './useDashboardActions';
import { useEmployeeDashboardModals } from './useEmployeeDashboardModals';
import { DashboardEmployee } from '../types';
import { EMPLOYEE_ZONES, DELEGATED_EMPLOYEE_ZONES_ALIASES } from '../constants';
import { EMPLOYEE_ZONES_ALIASES } from 'domain/shared/employee';

export const useZoneManagement = () => {
  const { data } = useShowContext<DashboardEmployee>();
  const { handleChangeZone } = useEmployeeDashboardActions();
  const { modalCallbacks } = useEmployeeDashboardModals();

  const employeeData = data.getData();

  const currentZone = (data.currentZone as keyof typeof EMPLOYEE_ZONES) || data.retentionRiskPriority;
  const allZones = Object.keys(EMPLOYEE_ZONES_ALIASES);
  const isDelegatedZone = currentZone === DELEGATED_EMPLOYEE_ZONES_ALIASES.DELEGATED;

  const zoneOptions = isDelegatedZone
    ? [
        {
          key: `zone-${currentZone}`,
          label: EMPLOYEE_ZONES[currentZone as keyof typeof EMPLOYEE_ZONES],
        },
      ]
    : allZones.map(zone => ({
        key: `zone-${zone}`,
        label: EMPLOYEE_ZONES[zone as keyof typeof EMPLOYEE_ZONES],
        disabled: zone === currentZone,
        onClick: () => handleChangeZone(employeeData, zone),
      }));

  const changeZoneCallbacks = {
    onSubmit: async (formData: any) => {
      await modalCallbacks.changeZone.onSubmit(formData);
    },
    onClose: () => {},
  };

  return {
    zoneOptions,
    changeZoneCallbacks,
    zones: EMPLOYEE_ZONES,
  };
};
